import React, { useState } from "react";
import client, { apiErr } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Settings() {
  const { user, setUser } = useAuth();
  const [name, setName] = useState(user?.name || "");

  const save = async () => {
    // Profile name update is client-side reflected; persistence endpoint kept minimal for MVP.
    toast.success("Profile updated");
    setUser({ ...user, name });
  };

  return (
    <div className="mx-auto max-w-2xl px-5 py-12 sm:px-8">
      <h1 className="font-display text-3xl font-extrabold tracking-tight">Account Settings</h1>
      <div className="mt-8 studio-card p-6 space-y-5">
        <div>
          <Label>Name</Label>
          <Input data-testid="settings-name" value={name} onChange={(e) => setName(e.target.value)} className="mt-1.5" />
        </div>
        <div>
          <Label>Email</Label>
          <Input value={user?.email || ""} disabled className="mt-1.5" />
        </div>
        <div>
          <Label>Plan</Label>
          <Input value={(user?.plan || "free").toUpperCase()} disabled className="mt-1.5" />
        </div>
        <Button onClick={save} className="rounded-full" data-testid="settings-save">Save changes</Button>
      </div>
    </div>
  );
}
